import Head from "next/head";
import styles from "@/styles/Home.module.css";
import { ComponentPrivacyPolicy } from "@/components/ui/Screens";

const PagePrivacyPolicy = () => {
	return (
		<div className={styles.container}>
			<Head>
				<title>Privacy Policy: Your Data Safety at Royal Air</title>
				<link rel="icon" href="/favicon.ico" />
				<meta
					property="og:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="twitter:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="description"
					content="Royal Air respects your privacy. Read our policy on how we protect your personal info while you use our services and visit our website."
				></meta>
			</Head>

			<main style={{ padding: 0, width: "100%" }}>
				<ComponentPrivacyPolicy />
			</main>
		</div>
	);
};

export default PagePrivacyPolicy;
